import Main from "@root/Main";
import { ComponentDefineDic, ComponentElem } from "@components/interfaces";
import IndexSortBar from "./IndexSortBar";
import Components from "@components/Compoents";
import IndexLocationList from "./IndexLocationList";
import IndexSearchbar from "./IndexSearchbar";
import HashtagList from "./HashtagList";
import ImageSlider from "@components/ui/ImageSlider";
import IndexPromoteImage from "./IndexPromoteImage";
import IndexPromoteArea from "./IndexPromoteArea";
import IndexBonus from "./IndexBonus";
import Utility from "../../ts/sframe/Utility";
import Popups from "../popups/Popups";
import LoginInvite from "../popups/LoginInvite";

let _componentDic: ComponentDefineDic =
{
  "index-sort-bar": {
    componentClass: IndexSortBar
  },

  "index-location-list": {
    componentClass: IndexLocationList
  },

  "index-searchbar": {
    componentClass: IndexSearchbar
  },

  "hashtag-list": {
    componentClass: HashtagList
  },

  "image-slider": {
    componentClass: ImageSlider
  },

  "index-promote-area": {
    componentClass: IndexPromoteArea
  },

  "index-promote-image": {
    componentClass: IndexPromoteImage
  },

  "index-bonus": {
    componentClass: IndexBonus
  },
}

let $root;

Main.preInitPage = () => {
}

Main.initPage = () => {
  $root = $("#page-content");

  new ImageSlider($root.find(`[component="image-slider"]`)[0] as ComponentElem);

  if (Utility.urlParams["first-time-login"] === "true") {
    if (Utility.urlParams["invite-code"]) {
      LoginInvite.instance.setInviteCode(Utility.urlParams["invite-code"]);
      Utility.adjustUrlParams(["invite-code"]);
    }
    Popups.to("login-invite");
    Utility.adjustUrlParams(["first-time-login"]);
  } else if (Utility.urlParams["invite-code"]) {
    Popups.to("login");
    Utility.adjustUrlParams(["invite-code"]);
  }
}

Components.registComponents(_componentDic);

